import {createStyles, createTheme, makeStyles, Theme} from "@material-ui/core/styles";

export const defaultPalette = {
    primary: {
        main: "#2563EB",
    },
    secondary: {
        main: "#6B7280",
    },
    background: {
        default: "#f9fafb",
        paper: "#ffffff",
    },
};

const commonOverrides = {
    MUIRichTextEditor: {
        root: {
            height: "100%",
        },
        container: {
            height: "100%",
        },
        editor: {
            height: "100%",
            minHeight: "3em",
            maxHeight: "50vh",
            padding: "14px",
            overflow: "auto",
        },
        placeHolder: {
            height: "100%",
            padding: "14px",
        },
        toolbar: {
            borderBottomStyle: "solid",
            borderBottom: "1px",
            borderBottomColor: "rgba(0, 0, 0, 0.23)",
        },
    },
    MuiDialog: {
        paperScrollPaper: {
            overflowY: "hidden" as const,
        },
    },
    MuiButton: {
        root: {
            borderRadius: "8px",
            textTransform: "none" as const,
            fontWeight: 600,
            fontSize: "0.875rem",
        },
        contained: {
            boxShadow: "none",
            "&:hover": {
                boxShadow: "0 1px 4px rgba(0,0,0,0.15)",
            },
        },
        outlined: {
            borderColor: "#D1D5DB",
        },
    },
    MuiPaper: {
        rounded: {
            borderRadius: "12px",
        },
    },
    MuiTableRow: {
        root: {
            "&:last-child td": {
                borderBottom: 0,
            },
        },
    },
    MuiTableCell: {
        root: {
            borderBottom: "1px solid #F3F4F6",
            padding: "12px 16px",
        },
        head: {
            fontWeight: 600,
            color: "#374151",
            fontSize: "0.8125rem",
        },
    },
    MuiChip: {
        root: {
            borderRadius: "6px",
            fontWeight: 500,
            fontSize: "0.75rem",
        },
    },
    MuiDrawer: {
        paper: {
            borderRight: "1px solid #E5E7EB",
            backgroundColor: "#ffffff",
        },
    },
    MuiListItem: {
        root: {
            borderRadius: "6px",
            marginBottom: "2px",
        },
    },
    MuiListSubheader: {
        root: {
            color: "#6B7280",
            fontWeight: 600,
            fontSize: "0.75rem",
            textTransform: "uppercase" as const,
            letterSpacing: "0.05em",
        },
    },
    MuiFab: {
        root: {
            boxShadow: "0 1px 4px rgba(0,0,0,0.15)",
        },
    },
    MuiInputBase: {
        root: {
            borderRadius: "8px",
        },
    },
    MuiOutlinedInput: {
        root: {
            borderRadius: "8px",
        },
    },
};

export const lightTheme = createTheme({
    palette: defaultPalette,
    overrides: commonOverrides,
    shape: {
        borderRadius: 8,
    },
    typography: {
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
        h1: {
            fontSize: "1.875rem",
            fontWeight: 700,
            color: "#111827",
        },
        h2: {
            fontSize: "1.5rem",
            fontWeight: 700,
            color: "#111827",
        },
        h3: {
            fontSize: "1.25rem",
            fontWeight: 600,
            color: "#111827",
        },
        body1: {
            color: "#374151",
        },
        body2: {
            color: "#6B7280",
        },
    },
});

export const darkTheme = createTheme({
    palette: {
        type: "dark",
        primary: {
            main: "#3B82F6",
        },
        background: {
            default: "#111827",
            paper: "#1F2937",
        },
    },
    overrides: commonOverrides,
    shape: {
        borderRadius: 8,
    },
});

export const THEMES = {
    light: lightTheme,
    dark: darkTheme,
};

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        centerFlex: {
            display: "flex",
            justifyContent: "center",
        },
        radioGroup: {
            display: "flex",
        },
        fullWidth: {
            width: "100% !important",
        },
        spaceAfter: {
            marginBottom: "1em !important",
        },
        spaceBefore: {
            marginTop: "1em !important",
        },
        spaceAround: {
            margin: "1em !important",
        },
        spaceBeforeAfter: {
            marginTop: "1em !important",
            marginBottom: "1em !important",
        },
        narrow: {
            maxWidth: "700px !important",
            margin: "0 auto !important",
        },
        minTableCell: {
            width: "1% !important",
            whiteSpace: "nowrap",
        },
        deletedRowOrCell: {
            height: 0,
            padding: 0,
            position: "absolute",
            borderBottom: "none",
        },
        hidden: {
            display: "none",
        },
        strikeThrough: {
            textDecoration: "line-through",
            color: theme.palette.grey.A400,
        },
        clickable: {
            cursor: "pointer",
        },
        fabWrapper: {
            float: "right",
            marginTop: "1em",
        },
        backdrop: {
            zIndex: theme.zIndex.drawer + 1,
            color: "#fff",
        },
        floatLeft: {
            float: "left",
        },
        floatRight: {
            float: "right",
        },
        wrapperClear: {
            clear: "both",
        },
        icon: {
            marginRight: theme.spacing(1),
            width: 24,
            height: 24,
        },
    })
);
